<template>
  <div>
    <b-overlay :show="showOverlay" rounded="sm" opacity="1" no-center>
      <div class="home-page-title">
        <img class="title-bg" :src="homeTitleBackground.location" />
        <div class="title-box">
          <div class="title" :style="`color: ${homeTitle.color}`">{{ homeTitle.context }}</div>
          <div class="subtitle" :style="`color: ${homeSubtitle.color}`">{{ homeSubtitle.context }}</div>
        </div>
      </div>
      <div class="page-wrapper">
        <PersonalInfo></PersonalInfo>
        <CourseLearning id="courseLearning"></CourseLearning>
      </div>
      <BulletinList v-if="refreshNews" :newsList="newsList"></BulletinList>
    </b-overlay>
  </div>
</template>

<script>
import Vue from 'vue'
import PersonalInfo from '@/components/HomePage/PersonalInfo'
import CourseLearning from '@/components/HomePage/CourseLearning'
import BulletinList from '@/components/HomePage/BulletinList'
import { mapState, mapGetters } from 'vuex'
import VueScrollTo from 'vue-scrollto'

const Home = Vue.extend({
  name: 'Home',
  data () {
    return {
      from: null,
      refreshNews: false
    }
  },
  components: {
    PersonalInfo,
    BulletinList,
    CourseLearning
  },
  computed: {
    ...mapState({
      newsList: (state) => state.resource.news
    }),
    ...mapGetters({
      homeTitle: 'resource/homeTitle',
      homeSubtitle: 'resource/homeSubtitle',
      homeTitleBackground: 'resource/homeTitleBackground'
    }),
    showOverlay () {
      return !(this.homeTitle && this.homeSubtitle && this.homeTitleBackground)
    }
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.from = from
    })
  },
  mounted () {
    this.$store.dispatch('auth/getAvatar')
    if (localStorage.startStudy !== '') {
      localStorage.startStudy = false
    }
    if (localStorage.startBreak !== '') {
      localStorage.startBreak = false
    }
    this.$store.dispatch('resource/getNews').then((res) => {
      this.refreshNews = true
    })
  },
  watch: {
    from (newValue, oldValue) {
      if (newValue !== oldValue && newValue.name === 'fullfillInfo') {
        VueScrollTo.scrollTo('#courseLearning', 500, { offset: -60 })
      }
    }
  }
})
export default Home
</script>

<style scoped>
.center-img {
  margin-top: 20px;
  margin-bottom: 50px;
}
.home-page-title {
  position: relative;
  height: 600px;
}
.title-bg {
  height: 100%;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.title-box {
  position: absolute;
  top: 25%;
  left: 50%;
  width: 800px;
  transform: translateX(-50%);
}
.title {
  font-size: 3.5rem;
  color: aliceblue;
  margin: 0;
}
.subtitle {
  font-size: 1.8rem;
  color: gainsboro;
  margin-top: 20px;
}
</style>
